import baseComponent from 'BASE/components/chat/chat.base.component.roomListClassification'
import room from "XC/components/chat/chat.component.room"

export default {
    mixins: [baseComponent],
    components: {
        room,
    }
};
